import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import {
  GET_REGISTRATION_PROGRESS_URL,
  REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS_URL
} from '@/constants/ApiConstants'

const state = {
  currentStep:
    window.localStorage.getItem('currentStep') ?
    window.localStorage.getItem('currentStep') :
    '0',
  totalSteps:
    window.localStorage.getItem('totalSteps') ?
    window.localStorage.getItem('totalSteps') :
    '0',
  coparentAdded:
    window.localStorage.getItem('coparentAdded') ?
    window.localStorage.getItem('coparentAdded') :
    'null',
  childAdded:
    window.localStorage.getItem('childAdded') ?
    JSON.parse(window.localStorage.getItem('childAdded')) :
    null,
  subscriptionActivated:
    window.localStorage.getItem('subscriptionActivated') ?
    JSON.parse(window.localStorage.getItem('subscriptionActivated')) :
    null,
  bankAccountAdded:
    window.localStorage.getItem('bankAccountAdded') ?
    JSON.parse(window.localStorage.getItem('bankAccountAdded')) :
    null,
  isBankAccountSkipped:
    window.localStorage.getItem('isBankAccountSkipped') ?
    JSON.parse(window.localStorage.getItem('isBankAccountSkipped')) :
    null,
  hasScheduledPayments:
    window.localStorage.getItem('hasScheduledPayments') ?
    JSON.parse(window.localStorage.getItem('hasScheduledPayments')) :
    null,
  hasScheduledPaymentsGotIt:
    window.localStorage.getItem('hasScheduledPaymentsGotIt') ?
    JSON.parse(window.localStorage.getItem('hasScheduledPaymentsGotIt')) :
    false,
  hasEventOrVisitations:
    window.localStorage.getItem('hasEventOrVisitations') ?
    JSON.parse(window.localStorage.getItem('hasEventOrVisitations')) :
    null,
  hasEventOrVisitationsGotIt:
    window.localStorage.getItem('hasEventOrVisitationsGotIt') ?
    JSON.parse(window.localStorage.getItem('hasEventOrVisitationsGotIt')) :
    false,
  isAppLocked:
    window.localStorage.getItem('isAppLocked') ?
    window.localStorage.getItem('isAppLocked') :
    true,
  isSubscriptionPastDue:
    window.localStorage.getItem('isSubscriptionPastDue') ?
    window.localStorage.getItem('isSubscriptionPastDue') :
    false,
};

const getters = {
  currentStep: (state) => state.currentStep,
  totalSteps: (state) => state.totalSteps,
  coparentAdded: (state) => state.coparentAdded,
  childAdded: (state) => state.childAdded,
  subscriptionActivated: (state) => state.subscriptionActivated,
  bankAccountAdded: (state) => state.bankAccountAdded,
  isBankAccountSkipped: (state) => state.isBankAccountSkipped,
  hasScheduledPayments: (state) => state.hasScheduledPayments,
  hasScheduledPaymentsGotIt: (state) => state.hasScheduledPaymentsGotIt,
  hasEventOrVisitations: (state) => state.hasEventOrVisitations,
  hasEventOrVisitationsGotIt: (state) => state.hasEventOrVisitationsGotIt,
  isAppLocked: state => {
    if (
      state.coparentAdded === 'finished' &&
      (!state.childAdded || state.childAdded === 'finished') &&
      (!state.subscriptionActivated || state.subscriptionActivated === 'finished') &&
      (state.isBankAccountSkipped || (!state.bankAccountAdded || state.bankAccountAdded === 'finished')) &&
      (!state.isSubscriptionPastDue)
    ) {
      window.localStorage.setItem('isAppLocked', 'false');
      return false
    }
    else {
      window.localStorage.setItem('isAppLocked', 'true');
      return state.isAppLocked;
    }
  }
};

const actions = {
   [action.GET_REGISTRATION_PROGRESS]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
      .get(GET_REGISTRATION_PROGRESS_URL)
      .then((response) => {
        commit(mutation.SET_REGISTRATION_PROGRESS, response.data.data);
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
  [action.REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS]({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      ApiService
      .post(REGISTRATION_PROGRESS_GOT_IT_TOOLTIPS_URL, data)
      .then((response) => {
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
  [action.SUBSCRIPTION_PAST_DUE_LOCK]({ commit }, isSubscriptionPastDue) {
     commit('SET_IS_SUBSCRIPTION_PAST_DUE', isSubscriptionPastDue)
  }
};

const mutations = {
  [mutation.SET_REGISTRATION_PROGRESS] (state, data) {
    // CURRENT STEP
    state.currentStep = data.currentStep;
    window.localStorage.setItem("currentStep", state.currentStep);
    //
    // TOTAL STEPS
    state.totalSteps = data.totalSteps;
    window.localStorage.setItem("totalSteps", state.totalSteps);

    // CO-PARENT
    state.coparentAdded = data.coparentAdded;
    window.localStorage.setItem("coparentAdded", state.coparentAdded);

    // CHILDREN
    state.childAdded = data.childAdded;
    window.localStorage.setItem("childAdded", JSON.stringify(state.childAdded));

    // SUBSCRIPTION
    state.subscriptionActivated = data.subscriptionActivated;
    window.localStorage.setItem("subscriptionActivated", JSON.stringify(state.subscriptionActivated));

    // BANK ACCOUNT
    state.bankAccountAdded = data.bankAccountAdded;
    window.localStorage.setItem("bankAccountAdded", JSON.stringify(state.bankAccountAdded));

    // SCHEDULE PAYMENTS
    state.hasScheduledPayments = data.hasScheduledPayments;
    window.localStorage.setItem("hasScheduledPayments", JSON.stringify(state.hasScheduledPayments));

    // SCHEDULE PAYMENTS - GOT IT
    state.hasScheduledPaymentsGotIt = !(data.tooltips.find(tooltip => tooltip.uiId === "SCHEDULE_PAYMENT").show);
    window.localStorage.setItem("hasScheduledPaymentsGotIt", JSON.stringify(state.hasScheduledPaymentsGotIt));

    // PARENTING SCHEDULE
    state.hasEventOrVisitations = data.hasEventOrVisitations;
    window.localStorage.setItem("hasEventOrVisitations", JSON.stringify(state.hasEventOrVisitations));

    // PARENTING SCHEDULE - GOT IT
    state.hasEventOrVisitationsGotIt = !(data.tooltips.find(tooltip => tooltip.uiId === "PARENTING_CALENDAR").show);
    window.localStorage.setItem("hasEventOrVisitationsGotIt", JSON.stringify(state.hasEventOrVisitationsGotIt));
  },
  [mutation.SET_IS_BANK_ACCOUNT_SKIPPED] (state, data) {
    // BANK ACCOUNT SKIPPED
    state.isBankAccountSkipped = data;
    window.localStorage.setItem("isBankAccountSkipped", JSON.stringify(state.isBankAccountSkipped));
  },
  [mutation.SET_IS_SUBSCRIPTION_PAST_DUE] (state, isSubscriptionPastDue) {
    state.isSubscriptionPastDue = isSubscriptionPastDue;
    isSubscriptionPastDue ?
      localStorage.setItem('isSubscriptionPastDue', isSubscriptionPastDue) :
      localStorage.removeItem('isSubscriptionPastDue')
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}
